import { Component, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Appropriator, AppropriatorsService } from 'src/app/services/appropriators.service';
import { AddAppropriatorModalComponent } from './add-appropriator-modal/add-appropriator-modal.component';
import { EditAppropriatorModalComponent } from './edit-appropriator-modal/edit-appropriator-modal.component';

export interface CreateAppropriatorRequest {
  name: string;
  email: string;
  address: string;
  phoneNumber: string;
}

@Component({
  selector: 'app-admin-appropriators',
  templateUrl: './admin-appropriators.component.html',
  styleUrls: ['./admin-appropriators.component.scss']
})
export class AdminAppropriatorsComponent {
  @Input() appropriators: Appropriator[];

  constructor(
    private modalService: NgbModal,
    private appropriatorsService: AppropriatorsService
  ) { }

  openNewAppropriatorModal() {
    const modalRef = this.modalService.open(AddAppropriatorModalComponent, { size: 'lg', centered: true });
    modalRef.result.then((result: CreateAppropriatorRequest) => {
      if (result) {
        this.createNewAppropriator(result);
      }
    });
  }

  openEditAppropriatorModal(appropriatorToEdit: Appropriator) {
    const modalRef = this.modalService.open(EditAppropriatorModalComponent, { size: 'lg', centered: true });
    modalRef.componentInstance.editAppName = appropriatorToEdit.name;
    modalRef.componentInstance.editAppEmail = appropriatorToEdit.email;
    modalRef.componentInstance.editAppAddress = appropriatorToEdit.address;
    modalRef.componentInstance.editAppPhoneNumber = appropriatorToEdit.phoneNumber;
    modalRef.result.then((result: CreateAppropriatorRequest) => {
      if (result) {
        this.editAppropriator(result, appropriatorToEdit.appropriatorId);
      }
    });
  }

  createNewAppropriator(request: CreateAppropriatorRequest) {
    this.appropriatorsService.postAppropriator(request.name, request.address, request.phoneNumber, request.email)
  }

  editAppropriator(request: CreateAppropriatorRequest, appropriatorId: number) {
    const originalAppropriator = this.appropriators.find(a => a.appropriatorId === appropriatorId);
    if (originalAppropriator.address === request.address &&
        originalAppropriator.email === request.email &&
        originalAppropriator.name === request.name &&
        originalAppropriator.phoneNumber === request.phoneNumber) return;

    const asAppropriator = {
      ...request,
      appropriatorId: appropriatorId
    };
    this.appropriatorsService.putAppropriator(asAppropriator);
  }
}
